module.exports = __webpack_public_path__ + "img/CM-DJ-24-Ford-Lifestyle.eab30612.jpg";